import { useState } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { DropdownThreeDotsIcon } from '@hivebrite/design-system/Dropdown';
import { FontAwesomeIcon } from '@hivebrite/design-system/FontAwesomeIcon';

import ReportContent from 'hb-react/frontoffice/components/ReportContent';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import ConfirmationModal from 'hb-react/shared/components/DesignSystem/Modal/ConfirmationModal';

import { destroyComment } from '../utils/actions';

const Edit = () => <FontAwesomeIcon height="16px" iconName="pen" />;

const Delete = () => <FontAwesomeIcon height="16px" iconName="trash-can" />;

const Report = () => (
  <FontAwesomeIcon height="16px" iconName="circle-exclamation" />
);

const ActionItems = ({
  commentUser,
  currentUser,
  id,
  isReply,
  itemToReport,
  onCloseReportContent,
  onDeleteComment,
  onEditComment,
  onReportItem,
}) => {
  const { currentNetwork } = useDefaultAppContexts();

  const [displayDeleteModal, setDisplayDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  let actionsItems = [];

  if (commentUser.id === currentUser?.id) {
    actionsItems = [
      {
        label: __('Edit'),
        icon: Edit,
        dataTestId: `editing-${isReply ? 'reply' : 'comment'}-as-current-user`,
        onClick: () => {
          onEditComment();
        },
      },
      {
        label: __('Delete'),
        dataTestId: `removing-${isReply ? 'reply' : 'comment'}-as-current-user`,
        icon: Delete,
        onClick: () => {
          setDisplayDeleteModal(true);
        },
      },
    ];
  } else if (currentNetwork?.network_config?.user_can_report_user_contents) {
    actionsItems.push({
      dataTestId: 'comments-report-content',
      icon: Report,
      label: I18n.t('web.content_reporting.call_to_action_title'),
      onClick: onReportItem,
    });
  }

  const onDestroyCommentSuccess = ({ id }) => {
    setDisplayDeleteModal(false);
    onDeleteComment({ id });
  };

  const handleDeleteItem = () => {
    setIsDeleting(true);
    destroyComment({
      id,
      currentUser,
      onResponse: onDestroyCommentSuccess,
    }).finally(() => setIsDeleting(false));
  };

  return (
    <DropdownWrapper display="block" color="asphalt">
      {actionsItems.length > 0 && (
        <DropdownThreeDotsIcon
          dataTestId={`${isReply ? 'reply' : 'comment'}-actions-dropdown`}
          items={actionsItems}
          wrapperStyles={{ position: 'absolute' }}
        />
      )}
      {displayDeleteModal && (
        <ConfirmationModal
          confirmButtonLabel={s__('Comments|Delete comment')}
          isLoading={isDeleting}
          onCloseModal={() => setDisplayDeleteModal(false)}
          onConfirmation={handleDeleteItem}
          title={s__('Comments|Delete comment')}
          text={
            isReply
              ? s__(
                  'Comments|Are you sure to delete your reply to this comment? This action is irreversible.',
                )
              : s__(
                  'Comments|Are you sure to delete your comment? This action is irreversible.',
                )
          }
        />
      )}
      {itemToReport && (
        <ReportContent
          id={itemToReport?.id}
          type="Comment"
          onCloseModal={onCloseReportContent}
        />
      )}
    </DropdownWrapper>
  );
};

export default ActionItems;

const DropdownWrapper = styled(Box)`
  width: 16px;
`;
